import { render, staticRenderFns } from "./PersonDialogForm.vue?vue&type=template&id=303998bb"
import script from "./PersonDialogForm.vue?vue&type=script&lang=js"
export * from "./PersonDialogForm.vue?vue&type=script&lang=js"
import style0 from "./PersonDialogForm.vue?vue&type=style&index=0&id=303998bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports